import React from "react";
import { Icon } from "@chakra-ui/icons";

import { ReactComponent as ParametreIcon } from "../../assets/parametre.svg";

export const Parametre = (props) => {
  return <Icon as={ParametreIcon} {...props} />;
};
